import { render } from "./CreateVolume.vue?vue&type=template&id=b301764a&scoped=true"
import script from "./CreateVolume.vue?vue&type=script&lang=js"
export * from "./CreateVolume.vue?vue&type=script&lang=js"

import "./CreateVolume.vue?vue&type=style&index=0&id=b301764a&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.3.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b301764a"]])

export default __exports__